import React from 'react';

const PageTitle = ({isMobile, title}) => {
  let pageTitle = title ? title : 'Jason\'s Wine &amp; Spirits';
  return isMobile ? (
    <div className="row">
      <div className="col-md-12 page-title-bar">
        <div className="page-title">{pageTitle}</div>
      </div>
    </div>
  ) : (
    <h1 className="page-title">{pageTitle}</h1>
  );
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/commons/pages/PageTitle.js